import {
  createNativeStackNavigator,
  NativeStackScreenProps,
} from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import React from 'react';
import { FieldRepeatableInstanceScreen } from 'screens/AssetScreen/Field/FieldRepeatableInstanceScreen';

import { FieldRepeatableListScreen } from './FieldRepeatableListScreen';

const Stack =
  createNativeStackNavigator<NavigationStacks['ASSETFIELDREPEATABLE']>();

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSET],
  Screens.ASSET_FIELDREPEATABLE
>;

export const FieldRepeatableStack: React.FC<Props> = ({
  route: {
    params: { assetId, groupId, sectionId },
  },
}) => (
  <Stack.Navigator
    initialRouteName={Screens.ASSETFIELDREPEATABLE_LIST}
    screenOptions={{
      headerShown: false,
    }}
  >
    <Stack.Screen
      name={Screens.ASSETFIELDREPEATABLE_LIST}
      component={FieldRepeatableListScreen}
      initialParams={{ assetId, groupId, sectionId }}
    />
    <Stack.Screen
      name={Screens.ASSETFIELDREPEATABLE_INSTANCE}
      component={FieldRepeatableInstanceScreen}
    />
  </Stack.Navigator>
);
